import { defineConfig } from '@react/chakra';

export const theme = defineConfig({
  globalCss: {
    html: {
      bg: 'gray.800',
      color: 'white',
    },
    body: {
      bg: 'gray.800',
      color: 'white',
    },
  },
  theme: {
    tokens: {
      shadows: {
        eclipse: {
          value:
            'rgb(31, 32, 40) 0px 0px 0px 0px, rgb(54, 163, 255) 0px 0px 12px 3px, rgba(0, 0, 0, 0) 0px 0px 0px 0px',
        },
      },
    },
  },
});
